import "./index.css"

import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { App } from "./app/App"
import { env } from "./app/env"
import { createSentryClient } from "./app/integrations/sentry"

if (env.PRISMIC_PAGE_BUILDER_SENTRY_ENABLED) createSentryClient()

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

declare global {
  interface Window {
    /** If specified, it represents the target repository. This is useful for running E2E tests in specific, temporary repositories */
    __repository__?: string
  }
}
